export default {
    items: [
        {
            name: 'Tableau de bord',
            url: '/dashboard',
            icon: 'ti-home'
        },
        {
            name: 'Utilisateurs ',
            url: '/adherents/index',
            icon: 'ti-user',
            children: [
                {
                    name: 'Tous les utilisateurs ',
                    url: '/adherents/index'
                },
                {
                    name: 'Ajouter un utilisateur',
                    url: '/adherents/add'
                },
                {
                    name: 'Modifier un utilisateur',
                    url: '/adherents/edit'
                },
                {
                    name: 'Groupe',
                    //url: '/usergroup/index',
                    toogle_dropdown : true,
                    children: [
                        {
                            name: 'Tous les groupes ',
                            url: '/usergroup/index'
                        },
                        {
                            name: 'Ajouter un groupe',
                            url: '/usergroup/add'
                        },
                        {
                            name: 'Modifier un groupe',
                            url: '/usergroup/edit'
                        }
                    ]
                },
            ]
        },
        {
            name: 'Outils',
            url: '/systems/index',
            icon: 'ti-truck',
            children: [
                {
                    name: 'Tous les outils',
                    url: '/systems/index'
                },
                {
                    name: 'Ajouter un outil',
                    url: '/systems/add'
                },
                {
                    name: 'Modifier un outil',
                    url: '/systems/edit'
                }
            ]
        },
        {
            name: 'Compteurs',
            url: '/sensors/index',
            icon: 'ti-pulse',
            children: [
                {
                    name: 'Tous les compteurs',
                    url: '/sensors/index'
                }
            ]
        },
        {
            name: 'Plaques',
            url: '/plates/index',
            icon: 'ti-layers',
            children: [
                {
                    name: 'Toutes les plaques',
                    url: '/plates/index'
                }
            ]
        },
        /*{
            name: 'Agenda',
            url: '/calendar',
            icon: 'ti-bar-chart'
        },*/
        {
            name: 'Extraction',
            url: '/extraction',
            icon: 'ti-export'
        },
    ]
}
